
import { Tooltip } from "@nextui-org/react";
import { AiFillEye } from 'react-icons/ai';
import { BsTrashFill } from "react-icons/bs";
import { FaFolder } from "react-icons/fa";

const Table = ({ data, columns, edit, explore, destroy }) => {

    const renderCell = (item, columnKey) => {
        const value = item[columnKey];

        switch (columnKey) {
            case "actions":
                return (
                    <span>
                        {(Boolean(edit)) && <Tooltip content="Modifier">
                            <AiFillEye onClick={e => {e.stopPropagation(); edit(item)}} size={24} fill="#979797" />
                        </Tooltip>}

                        {(Boolean(explore)) && <Tooltip content="Explorer">
                            <FaFolder onClick={e => {e.stopPropagation(); explore(item)}} size={24} fill="#FF9F00" />
                        </Tooltip>}

                        {(Boolean(destroy)) && <Tooltip content="Supprimer" color="error">
                            <BsTrashFill onClick={e => {e.stopPropagation(); destroy(item)}} size={24} fill="#FF0080" />
                        </Tooltip>}
                    </span>
                );
            default:
                return value.toString();
        }
    };

    return (<>
        <table className="test">
            <thead>
                <tr>
                    {columns.map((column) => <th key={column.key}>{column.label}</th>)}
                </tr>
            </thead>
            <tbody>
                {data.map((item) => <tr onClick={e => {edit(item)}} key={item.id}>
                    {columns.map((column, i) => <td key={i}>{renderCell(item, column.key)}</td>)}
                </tr>)}
            </tbody>
        </table>
    </>
    );
}

export default Table;